import React, { useState, useEffect } from "react";
import {
  Paper,
  Grid,
  Table,
  FormControl,
  TableHead,
  TableRow,
  TableContainer,
  TableBody,
  TableCell,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  IconButton,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import Pagination from "@material-ui/lab/Pagination";
import ConfirmDialog from "../common/confirmDialog/ConfirmDialog";
import ProductView from "./ProductView";
import ReactSelect from "react-select";
import api from "../../api";
import utils from "../../utils/utils";
import DialogTitle from "@material-ui/core/DialogTitle";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import ListIcon from "@material-ui/icons/List";
import Alert from "@material-ui/lab/Alert";
import moment from "moment";
import Tooltip from "@material-ui/core/Tooltip";
import { useDispatch, useSelector } from "react-redux";
import { KeyboardDateTimePicker } from "@material-ui/pickers";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { productTypeList, StatusEnum } from "../../enums/enums";
import { ProductTypes } from "../../redux/actions/_types";
import { useNavigate } from "react-router-dom";

export default function Product({ setIsLoading, setDataToast }) {
  let navigate = useNavigate();
  const [dataTable, setDataTable] = useState();
  const [companiesList, setCompaniesList] = useState();
  const [categoriesList, setCategoriesList] = useState();
  const [statusList, setStatusList] = useState(
    utils.setStatusDataInSearchList(Object.values(StatusEnum))
  );
  const [servicesData, setServicesData] = useState([]);
  const [filterProductName, setFilterProductName] = useState("");
  const itemsPerPage = 10;
  const [paginationData, setPaginationData] = useState({
    amount: 0,
    currentPage: 1,
  });
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    id: undefined,
  });
  const [viewDialog, setViewDialog] = useState(false);
  const [viewData, setViewData] = useState();
  const [openEdit, setOpenEdit] = React.useState(false);
  const [openPriceHistory, setOpenPriceHistory] = React.useState(false);
  const [error, setError] = useState(false);
  const [defaultValues, setDefaultValues] = useState();
  const [priceHistoryData, setPriceHistoryData] = useState();
  const [companyFilter, setCompanyFilter] = useState();
  const [statusFilter, setStatusFilter] = useState(
    statusList.find((status) => status.key === 1)
  );
  const [editPrice, setEditPrice] = useState(false);
  const dispatch = useDispatch();
  const productReducer = useSelector((state) => state.productReducer);

  const handleCloseEdit = () => {
    setIsLoading(false);
    setOpenEdit(false);
  };

  const handleClosePriceHistory = () => {
    setIsLoading(false);
    setOpenPriceHistory(false);
    setPriceHistoryData();
  };

  const handleImputPriceChangeEdit = (e) => {
    setDefaultValues({ ...defaultValues, price: parseFloat(e.target.value) });
  };

  const hanldeInputDatePriceChangeEdit = (e) => {
    if (e) {
      setDefaultValues({
        ...defaultValues,
        datePrice: moment(e).format("YYYY-MM-DDTHH:mm"),
      });
    } else {
      setDefaultValues({
        ...defaultValues,
        datePrice: null,
      });
    }
  };

  function uploadPdf(e) {
    let files = e.target.files;
    if (files) {
      setIsLoading(true);

      let data = new FormData();
      let file = files.item(0);
      if (file.type === "application/pdf") {
        data.append("files", files.item(0));

        api
          .uploadFile(data)
          .then((res) => {
            let file = res.data.files[0].url;
            setDefaultValues({ ...defaultValues, termsAndConditions: file });
            setIsLoading(false);
          })
          .catch(() => {
            setIsLoading(false);
            shortError("Ocurrió un error al subir el archivo.");
          });
      } else {
        setIsLoading(false);
        shortError("Solo se permite un archivo de formato PDF.");
      }
    }
  }

  function save() {
    setIsLoading(true);
    if (!defaultValues.termsAndConditions.trim()) {
      setIsLoading(false);
      shortError("Debe ingresar un PDF válido");
    } else if (!defaultValues.price) {
      setIsLoading(false);
      shortError("Debe ingresar un precio válido");
    } else if (!defaultValues.datePrice) {
      setIsLoading(false);
      shortError("Debe ingresar una fecha válida");
    } else if (!defaultValues.categoryId) {
      setIsLoading(false);
      shortError("Debe ingresar una categoría válida");
    } else {
      var body = {
        rutaPdf: defaultValues.termsAndConditions,
        precio: parseFloat(defaultValues.price),
        fechaPrecio: moment(defaultValues.datePrice).format("YYYY-MM-DDTHH:mm"),
        categoriaId: defaultValues.categoryId,
      };
      api
        .editProductPdfOrPrice(defaultValues.id, body)
        .then((res) => {
          setOpenEdit(false);
          setDataToast({
            active: true,
            message:
              "Editado correctamente con el Id: " +
              res.data["id"] +
              " para el producto de Id: " +
              defaultValues.id,
            type: "success",
          });
          changePage(undefined, paginationData.currentPage);
          handleCloseEdit();
        })
        .catch((err) => {
          if (err.response.data.errores !== undefined) {
            if (Array.isArray(err.response.data.errores)) {
              err.response.data.errores.forEach((message) => {
                shortError(message);
              });
            } else {
              shortError(err.response.data.errores);
            }
          } else {
            shortError("Ocurrio un error");
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
      setError(false);
    }
  }

  function shortError(message) {
    setDataToast({
      active: true,
      message: message,
      type: "error",
    });
  }

  function setFilter(e) {
    let name = e.target.name;
    if (name === "name") {
      e.target.value = e.target.value.replace(/[^A-Za-zÁÉÍÓÚáéíóúñÑ ]/g, "");
    }

    let value = e.target.value;

    setFilterProductName(value);
  }

  function search(e) {
    e.preventDefault();
    let filters = {
      companyId: companyFilter ? companyFilter.key : null,
      companyLabel: companyFilter ? companyFilter.label : "",
      productName: filterProductName ? filterProductName : "",
      status: statusFilter ? statusFilter.key : StatusEnum.Active.Id,
    };
    dispatch({
      type: ProductTypes.PRODUCT_REQUEST,
      filters,
    });
    reloadData(1, 1, itemsPerPage, filters);
  }

  const changePage = (event, value) => {
    reloadDataPage(value);
  };

  const reloadDataPage = (page) => {
    let from = (page - 1) * itemsPerPage + 1;
    let to = page * itemsPerPage;
    let filters = {
      companyId: companyFilter ? companyFilter.key : null,
      companyLabel: companyFilter ? companyFilter.label : "",
      productName: filterProductName ? filterProductName : "",
      status: statusFilter ? statusFilter.key : StatusEnum.Active.Id,
    };
    reloadData(page, from, to, filters);
  };

  function reloadData(page, from, to, filters) {
    setIsLoading(true);
    api
      .getProducts(
        filters.companyId,
        filters.productName,
        from,
        to,
        true,
        filters.status
      )
      .then((res) => {
        let data = res.data;
        let currentPage = page;
        let amount = paginationData.amount;
        amount = Math.ceil(data.cantidad / itemsPerPage);

        setPaginationData({
          amount: amount,
          currentPage: currentPage,
        });

        let list = [];
        data.productos.forEach((item) => {
          list.push({
            id: item.productoId,
            name: item.nombre,
            company: item.compania,
            price: item.precio,
            configuracionGrillaId: item.configuracionGrillaId,
            estado: item.estado,
          });
        });

        setDataTable(list);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setDataToast({
          active: true,
          type: "error",
          message: "Ocurrió un error.",
        });
      });
  }

  const applyDataFilters = (companies) => {
    var dataFilters = productReducer.filters;
    if (dataFilters && Object.keys(dataFilters).length) {
      let body = dataFilters;
      if (dataFilters?.status) {
        const statusData = statusList.find(
          (status) => status.label === StatusEnum.Active.Text
        );
        if (statusData) {
          setStatusFilter(statusData);
        }
      }
      if (dataFilters?.companyId) {
        let company = companies.data.find(
          (x) => x.id === dataFilters.companyId
        );
        setCompanyFilter({
          key: company.id ? company.id : undefined,
          label: company.nombre ? company.nombre : "",
          id: company.id ? company.id : undefined,
        });

        setFilterProductName(dataFilters.productName);
      }
      reloadData(1, 1, itemsPerPage, dataFilters);
    } else {
      setIsLoading(false);
    }
  };

  const closePreDelete = () => {
    setDeleteDialog({ ...deleteDialog, open: false });
  };

  const preDelete = (id) => {
    setDeleteDialog({ open: true, id: id });
  };

  function deleteProduct(id) {
    closePreDelete();
    setIsLoading(true);
    api
      .deleteProduct(id)
      .then((res) => {
        let newDataTable = [];
        dataTable.forEach((product) => {
          if (product.id !== id) {
            newDataTable.push(product);
          }
        });

        setDataTable(newDataTable);
        setIsLoading(false);
        utils.alertSuccess("Producto N° " + id, "Eliminado correctamente.");
      })
      .catch((err) => {
        setIsLoading(false);
        if (Array.isArray(err.response.data.errores)) {
          err.response.data.errores.map((m) => {
            utils.alertError("Producto N° " + id, m);
          });
        } else {
          shortError("Ocurrió un error");
        }
      });
  }

  function viewProduct(id) {
    setIsLoading(true);
    api
      .getProduct(id, statusFilter.value)
      .then((res) => {
        let data = res.data;
        let servicesList = utils.setDataInList(data.servicios);
        let categoryName = data.categoria;
        if (data.categoriaExterna != null) {
          categoryName = data.categoria + " - " + data.categoriaExterna;
        }
        setViewData({
          id: data.id,
          services: servicesList,
          features: data.caracteristicas.map(x => x.nombre),
          name: data.nombre,
          description: data.descripcion,
          period: data.periodo,
          termsAndConditions: data.rutaPdf,
          companyId: data.companiaId,
          company: data.compania,
          price: data.precio,
          costCenter: data.centroCosto,
          categoryId: data.categoriaId,
          category: categoryName,
          allowBuyBack: data.permitirRecompra,
          externalProduct: data.productoExterno,
          paymentMethodName: data.medioPagoNombre,
          productType: productTypeList.find((x) => x.key === data.tipo),
          vehicleTypes: data.tiposVehiculos?.map(({ id, nombre }) => ({
            key: id,
            value: id,
            text: nombre,
          })),
        });

        setIsLoading(false);
        setViewDialog(true);
      })
      .catch((err) => {
        setIsLoading(false);
        shortError("Ocurrió un error.");
      });
  }

  function PriceHistory(id) {
    setIsLoading(true);
    api
      .getPricesByProductId(id)
      .then((res) => {
        const currentDate = moment();
        const pastDates = res.data.filter((item) =>
          moment(item.fechaPrecio).isBefore(currentDate)
        );
        if (pastDates.length > 0) {
          const closestDate = pastDates.reduce((prev, curr) => {
            const prevDiff = Math.abs(
              moment(prev.fechaPrecio).diff(currentDate)
            );
            const currDiff = Math.abs(
              moment(curr.fechaPrecio).diff(currentDate)
            );
            return currDiff < prevDiff ? curr : prev;
          });
          setPriceHistoryData(
            res.data.map(
              ({
                id,
                fechaPrecio,
                precio,
                nombreCategoria,
                productoId,
                idCategoria,
                rutaPdf,
              }) => {
                return {
                  id,
                  fechaPrecio,
                  precio,
                  idCategoria,
                  nombreCategoria,
                  productoId,
                  rutaPdf,
                  isEditValid: moment(fechaPrecio).isAfter(currentDate),
                  isClosestToDate: closestDate.fechaPrecio === fechaPrecio,
                };
              }
            )
          );
        } else {
          setPriceHistoryData([]);
        }
        setIsLoading(false);
        setOpenPriceHistory(true);
      })
      .catch((err) => {
        shortError("Ocurrió un error al obtener el historial de precios.");
        setIsLoading(false);
      });
  }

  async function PriceEdit(id) {
    setIsLoading(true);
    try {
      const res = await api.getProduct(id, StatusEnum.Active.Id);
      const data = res.data;
      const servicesList = utils.setDataInList(data.servicios);
      const services = servicesList.map((s) => s.value);
      setServicesData(services);

      const categoriesByCompanyList = await api.getCategoriesByCompany(
        data.companiaId
      );
      setCategoriesList(utils.setDataInList(categoriesByCompanyList.data));
      setDefaultValues({
        id: data.id,
        services: servicesData,
        name: data.nombre,
        description: data.descripcion,
        period: data.periodo,
        termsAndConditions: data.rutaPdf,
        companyId: data.companiaId,
        company: data.compania,
        price: data.precio,
        priceId: data.precioId,
        costCenter: data.centroCosto,
        categoryId: data.categoriaId,
        category: data.categoria,
        datePrice: moment(new Date().setHours(0, 1, 0)).format(
          "YYYY-MM-DD HH:mm"
        ),
      });

      setIsLoading(false);
      setOpenEdit(true);
    } catch (err) {
      setIsLoading(false);
      shortError("Ocurrió un error.");
    }
  }

  function openEditPriceHistoryById(id) {
    setIsLoading(true);
    var data = priceHistoryData.find((item) => item.id === id);
    if (data) {
      api
        .getProduct(data.productoId, StatusEnum.Active.Id)
        .then((res) => api.getCategoriesByCompany(res.data.companiaId))
        .then((res2) => {
          setCategoriesList(utils.setDataInList(res2.data));
          setDefaultValues({
            id: data.productoId,
            priceId: data.id,
            termsAndConditions: data.rutaPdf,
            price: data.precio,
            datePrice: moment(data.fechaPrecio).format("YYYY-MM-DD HH:mm"),
            categoryId: data.idCategoria,
          });

          setOpenEdit(true);
          setEditPrice(true);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error("Error al cargar las categorías:", error);
          setIsLoading(false);
        });
    } else {
      console.error("No se encontró un objeto con el ID proporcionado.");
      setIsLoading(false);
    }
  }

  function updatePriceHistoryById() {
    setIsLoading(true);
    if (!defaultValues.termsAndConditions.trim()) {
      shortError("Debe ingresar un PDF válido");
    } else if (!defaultValues.price) {
      shortError("Debe ingresar un precio válido");
    } else if (!defaultValues.datePrice) {
      shortError("Debe ingresar una fecha válida");
    } else if (!defaultValues.categoryId) {
      shortError("Debe ingresar una categoría válida");
    } else {
      var body = {
        rutaPdf: defaultValues.termsAndConditions,
        precio: parseFloat(defaultValues.price),
        fechaPrecio: moment(defaultValues.datePrice).format("YYYY-MM-DDTHH:mm"),
        categoriaId: defaultValues.categoryId,
      };
      api
        .updatePricesByProductsId(defaultValues.id, defaultValues.priceId, body)
        .then((res) => {
          setOpenEdit(false);
          setDataToast({
            active: true,
            message: "Editado correctamente.",
            type: "success",
          });
          PriceHistory(defaultValues.id);
          setIsLoading(false);
          setEditPrice(false);
          handleCloseEdit();
          setError(false);
        })
        .catch((err) => {
          setIsLoading(false);
          if (err.response.data.errores !== undefined) {
            if (Array.isArray(err.response.data.errores)) {
              err.response.data.errores.forEach((message) => {
                shortError(message);
              });
            } else {
              shortError(err.response.data.errores);
            }
          } else {
            shortError("Ocurrio un error");
          }
        });
    }
    setIsLoading(false);
  }

  function shortError(message) {
    setDataToast({
      active: true,
      message: message,
      type: "error",
    });
  }

  function validate() {
    let response = false;

    if (defaultValues.termsAndConditions) response = true;

    return response;
  }

  useEffect(() => {
    setDefaultValues({
      ...defaultValues,
      datePrice: moment(new Date().setHours(0, 1, 0)).format(
        "YYYY-MM-DD HH:mm"
      ),
    });
    setIsLoading(true);

    Promise.all([
      api.getCompanies().then((res) => {
        applyDataFilters(res);
        setCompaniesList(utils.setDataInSearchList(res.data));
      }),
    ])
      .then(() => setIsLoading(false))
      .catch((err) => {
        setIsLoading(false);
        shortError("Ocurrió un error");
      });
  }, []);

  return (
    <>
      <Paper className="c-grid" elevation={3}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid className="c-grid-header" container spacing={1}>
              <Grid item xs={6}>
                <h2>PRODUCTOS</h2>
              </Grid>
              <Grid item xs={6}>
                <Button
                  onClick={() => navigate("/producto/crear")}
                  className="c-grid-btn c-btn-success"
                  variant="contained"
                >
                  Crear nuevo
                </Button>
              </Grid>
            </Grid>
          </Grid>

          <Grid className="c-grid-header-filter c-mt-10" item xs={12}>
            <form onSubmit={search}>
              <Grid container spacing={1}>
                <Grid item md={3} xs={12}>
                  <FormControl variant="outlined" fullWidth={true} size="small">
                    <ReactSelect
                      placeholder="Buscar compañias..."
                      name="company"
                      onChange={(e) => {
                        setCompanyFilter(e);
                      }}
                      options={companiesList}
                      isClearable={true}
                      required
                      value={companyFilter ?? undefined}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={3} xs={12}>
                  <TextField
                    fullWidth={true}
                    variant="outlined"
                    onChange={setFilter}
                    size="small"
                    label="Nombre"
                    value={filterProductName}
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <FormControl variant="outlined" fullWidth={true} size="small">
                    <ReactSelect
                      placeholder="Estado del producto..."
                      name="status"
                      onChange={(e) => {
                        setStatusFilter(e);
                      }}
                      options={statusList}
                      value={statusFilter}
                      required
                    />
                  </FormControl>
                </Grid>
                <Grid item md={3} xs={12}>
                  <Button
                    className="c-btn-info c-mt-2"
                    variant="contained"
                    fullWidth={true}
                    type="submit"
                    startIcon={<SearchIcon />}
                  >
                    Buscar
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Paper>

      {dataTable && dataTable.length > 0 && (
        <Paper className="c-mt-20 c-grid-results" elevation={3}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TableContainer>
                <Table className="c-table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell className="c-w-5">N° de Producto</TableCell>
                      <TableCell className="c-w-30">Nombre</TableCell>
                      <TableCell className="c-w-25">Compañia</TableCell>
                      <TableCell className="c-w-15">Precio</TableCell>
                      <TableCell className="c-w-5">Habilitado</TableCell>
                      <TableCell className="c-w-20">Opciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dataTable.map(
                      ({
                        id,
                        name,
                        company,
                        price,
                        configuracionGrillaId,
                        configuracionTemplateMail,
                        estado,
                      }) => (
                        <TableRow key={id}>
                          <TableCell className="c-w-5">{id}</TableCell>
                          <TableCell className="c-w-30">{name}</TableCell>
                          <TableCell className="c-w-25">{company}</TableCell>
                          <TableCell className="c-w-15">
                            {price && <strong>$ {price}</strong>}
                          </TableCell>
                          <Tooltip
                            title="El producto estará habilitado si tiene configurada la grilla y la compañía tiene templates de mail asignados."
                            arrow
                          >
                            {configuracionGrillaId &&
                            !configuracionTemplateMail ? (
                              <TableCell className="c-w-5">
                                <CheckIcon
                                  style={{ color: "green" }}
                                ></CheckIcon>
                              </TableCell>
                            ) : (
                              <TableCell className="c-w-5">
                                <CloseIcon style={{ color: "red" }}></CloseIcon>
                              </TableCell>
                            )}
                          </Tooltip>
                          {estado === StatusEnum.Active.Id ? (
                            <TableCell className="c-w-20">
                              <Tooltip title="Ver" arrow>
                                <IconButton
                                  className="c-grid-btn-info button-grid"
                                  onClick={() => viewProduct(id)}
                                >
                                  <SearchIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Editar" arrow>
                                <IconButton
                                  className="c-grid-btn-edit button-grid"
                                  onClick={() =>
                                    navigate("/producto/" + id + "/editar")
                                  }
                                >
                                  <CreateIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Dar de baja" arrow>
                                <IconButton
                                  className="c-grid-btn-cancel button-grid"
                                  onClick={() => preDelete(id)}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip
                                title="Historial de precios y categorías"
                                arrow
                              >
                                <IconButton
                                  className="c-grid-btn-info button-grid"
                                  onClick={() => PriceHistory(id)}
                                >
                                  <ListIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Editar precio / categoría" arrow>
                                <IconButton
                                  className="c-grid-btn-success button-grid"
                                  onClick={() => PriceEdit(id)}
                                >
                                  <MonetizationOnIcon />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          ) : (
                            <TableCell className="c-w-20">
                              <Tooltip title="Ver" arrow>
                                <IconButton
                                  className="c-grid-btn-info button-grid"
                                  onClick={() => viewProduct(id)}
                                >
                                  <SearchIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip
                                title="Historial de precios y categorías"
                                arrow
                              >
                                <IconButton
                                  className="c-grid-btn-info button-grid"
                                  onClick={() => PriceHistory(id)}
                                >
                                  <ListIcon />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          )}
                        </TableRow>
                      )
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid
              item
              xs={12}
              container
              direction="column"
              alignItems="center"
              justify="center"
            >
              <Pagination
                className="c-pagination"
                onChange={changePage}
                page={paginationData.currentPage}
                count={paginationData.amount > 1 ? paginationData.amount : 0}
                shape="rounded"
              />
            </Grid>
          </Grid>
        </Paper>
      )}

      {dataTable && dataTable.length === 0 && (
        <Paper className="c-mt-20" elevation={3}>
          <Grid container spacing={1}>
            <Grid item xs={12} className="c-text-center">
              <h5>No se encontraron resultados.</h5>
            </Grid>
          </Grid>
        </Paper>
      )}

      {deleteDialog !== undefined && (
        <ConfirmDialog
          open={deleteDialog.open}
          message={"¿Desea eliminar el producto N° " + deleteDialog.id + " ?"}
          cancelAction={closePreDelete}
          confirmAction={() => deleteProduct(deleteDialog.id)}
        />
      )}

      {viewDialog !== false && (
        <Dialog
          open={viewDialog}
          onClose={() => setViewDialog(false)}
          maxWidth="md"
        >
          <DialogContent className="c-p-30">
            {viewData !== undefined && (
              <ProductView
                data={viewData}
                handleClose={() => setViewDialog(false)}
              />
            )}
          </DialogContent>
        </Dialog>
      )}

      {openEdit !== false && (
        <Dialog
          open={openEdit}
          onClose={handleCloseEdit}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            Actualizar Precio / Categoría
          </DialogTitle>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <DialogContent>
              <KeyboardDateTimePicker
                style={{ width: "100%" }}
                value={defaultValues.datePrice}
                onChange={hanldeInputDatePriceChangeEdit}
                label="Fecha del precio"
                format="yyyy-MM-dd HH:mm"
                minDate={moment(new Date())}
                minDateMessage="La fecha seleccionada no puede ser anterior a la fecha actual."
              />

              <TextField
                style={{ width: "100%", marginTop: "10px" }}
                autoFocus
                margin="dense"
                id="price"
                type="number"
                label="Nuevo Precio"
                onChange={handleImputPriceChangeEdit}
                value={defaultValues.price}
                fullWidth
                error={error}
              />
              <Autocomplete
                style={{ width: "100%", marginTop: "10px" }}
                options={categoriesList}
                getOptionLabel={(option) => option.text || ""}
                value={
                  categoriesList.find(
                    (category) => category.key === defaultValues.categoryId
                  ) || null
                }
                onChange={(e, c) => {
                  setDefaultValues({
                    ...defaultValues,
                    categoryId: c?.key || undefined,
                  });
                }}
                name="category"
                freeSolo={false}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    label="Categoría..."
                    variant="outlined"
                    onError={"Debe ingresar una categoría válida"}
                  />
                )}
              />

              {defaultValues.termsAndConditions && (
                <Alert
                  style={{ width: "100%", marginTop: "10px" }}
                  severity="success"
                >
                  PDF Subido
                  <a href={defaultValues.termsAndConditions} target="_blank">
                    aqui.
                  </a>
                </Alert>
              )}

              <input
                className="c-none"
                id="signature"
                type="file"
                accept="application/pdf"
                onChange={uploadPdf}
              />

              <label htmlFor="signature" style={{ marginTop: "10px" }}>
                <Button
                  className="c-btn-info c-mb-5 c-mt-10"
                  variant="contained"
                  component="span"
                >
                  Subir PDF
                </Button>
              </label>
            </DialogContent>
          </div>
          <DialogActions>
            <Button onClick={handleCloseEdit} className="c-btn-cancel">
              Cancelar
            </Button>
            {!editPrice ? (
              <Button
                onClick={save}
                className="c-btn-success"
                disabled={!validate()}
              >
                Aceptar
              </Button>
            ) : (
              <Button
                onClick={updatePriceHistoryById}
                className="c-btn-success"
                disabled={!validate()}
              >
                Aceptar
              </Button>
            )}
          </DialogActions>
        </Dialog>
      )}

      {openPriceHistory !== false && (
        <Dialog
          open={openPriceHistory}
          onClose={handleClosePriceHistory}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle>Historial de Precios y Categorías</DialogTitle>
          <Paper className="c-grid-results">
            <Grid container>
              <Grid item xs={12}>
                <TableContainer>
                  <Table className="c-table" size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell className="c-w-70">Fecha Importe</TableCell>
                        <TableCell className="c-w-30">Importe</TableCell>
                        <TableCell className="c-w-70">Categoria</TableCell>
                        {priceHistoryData.some((data) => data.isEditValid) && (
                          <TableCell className="c-w-20">Opciones</TableCell>
                        )}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {priceHistoryData.map(
                        ({
                          id,
                          fechaPrecio,
                          precio,
                          nombreCategoria,
                          isEditValid,
                          isClosestToDate,
                        }) => (
                          <TableRow
                            key={id}
                            className={isClosestToDate ? "current-date" : ""}
                          >
                            <TableCell className="c-w-50">
                              {moment(fechaPrecio)
                                .format("DD-MM-YYYY HH:mm")
                                .toString()}
                            </TableCell>
                            <TableCell className="c-w-30">$ {precio}</TableCell>
                            <TableCell className="c-w-70">
                              {nombreCategoria}
                            </TableCell>
                            {priceHistoryData.some(
                              (data) => data.isEditValid
                            ) && (
                              <TableCell
                                className="c-w-30"
                                style={{ height: 50 }}
                              >
                                {isEditValid && (
                                  <Tooltip title="Editar" arrow>
                                    <IconButton
                                      className="c-grid-btn-edit button-grid"
                                      onClick={() =>
                                        openEditPriceHistoryById(id)
                                      }
                                    >
                                      <CreateIcon />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </TableCell>
                            )}
                          </TableRow>
                        )
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </Paper>

          <DialogActions>
            <Button
              onClick={handleClosePriceHistory}
              className="c-grid-btn c-btn-info"
              variant="contained"
            >
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
